__turbopack_context__.v({
  "className": "_69DE9a_className",
  "variable": "_69DE9a_variable",
});
